import { defineFcm } from '../shared/factory';

export const FCM_PETITION_EDIT_TYPESENSE_DECISION_MAKER_SEARCH = defineFcm(
	'petition_edit_typesense_decision_maker_search',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'Petition edit page decision maker search',
		description: 'Use Typesense for decision maker search on the petition edit page instead of the search service',
		import: false,
		deprecated: 'Typesense productized — decision maker search always uses Typesense. Safe to delete after 2026-06-09.',
	});
